import { ref as w, computed as p, useId as S, openBlock as r, createElementBlock as u, createElementVNode as x, toDisplayString as f, createVNode as d, withDirectives as B, unref as b, normalizeClass as V, withKeys as g, withModifiers as m, vModelText as D, withCtx as N, createCommentVNode as $ } from "vue";
import y from "../../atoms/icon-core/icon-core.vue.js";
import A from "./select-box-list/select-box-list.vue.js";
/* empty css                                    */
const T = { class: "ds-select-box-auto" }, E = {
  "aria-live": "assertive",
  role: "status",
  "aria-atomic": "true",
  class: "ds-screen-reader-visible"
}, K = { class: "ds-position-relative ds-display-flex ds-align-items-center" }, j = ["aria-activedescendant", "aria-expanded", "aria-describedby", "aria-controls", "maxlength", "placeholder", "onKeydown"], z = ["aria-label"], H = ["aria-label"], M = {
  key: 0,
  class: "ds-padding-x-24 ds-padding-y-12"
}, O = ["id"], Z = /* @__PURE__ */ Object.assign({
  name: "DsSelectBoxSearchAutocomplete"
}, {
  __name: "select-box-search-autocomplete",
  props: {
    options: {
      type: Array,
      required: !0
    },
    labels: {
      type: Object,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    opened: {
      type: Boolean,
      required: !0
    },
    focusIndex: {
      type: Number,
      required: !0
    },
    value: {
      type: String,
      required: !0
    },
    maxLength: {
      type: Number,
      required: !0
    }
  },
  emits: ["close", "open", "value", "focus", "selection-cleared", "search-submitted"],
  setup(o, { emit: C }) {
    const i = o, s = w(), h = w(null), a = C, c = p(() => {
      const t = s.value ? i.options.filter(
        (e) => e.text.toLowerCase().replace(/\s/g, "").includes(s.value.toLowerCase().replace(/\s/g, ""))
      ) : [];
      return t == null ? void 0 : t.map((e) => ({
        ...e,
        highlightedText: e.text.replace(
          new RegExp(s.value, "gi"),
          (l) => "<strong>" + l + "</strong>"
        )
      }));
    }), L = p(() => i.opened ? `${c.value.length} ${i.labels.results}` : i.value ? i.value : ""), I = p(() => i.focusIndex > 0 ? `${n}-select-box-list-${i.focusIndex}` : null), n = S();
    function q(t) {
      const e = t.target.value;
      s.value = e.replace(/[^a-zA-Z_ +/?]+/, ""), s.value ? a("open") : a("close"), e.length >= 3 && (clearTimeout(h.value), h.value = setTimeout(() => {
        a("input-typed", { label: e, results: c.value });
      }, 2e3));
    }
    function k(t) {
      s.value = "", a("value", ""), (t == null ? void 0 : t.label) === "cross-circle-fill" && a("selection-cleared", t);
    }
    function v(t) {
      const e = t.value || s.value;
      t.text && (s.value = t.text), a("value", e), a("close");
    }
    return (t, e) => (r(), u("div", T, [
      x("div", E, f(L.value), 1),
      x("div", K, [
        d(y, {
          category: "interface",
          name: "search",
          class: "ds-select-box-auto__icon"
        }),
        B(x("input", {
          "onUpdate:modelValue": e[0] || (e[0] = (l) => s.value = l),
          "aria-activedescendant": I.value,
          "aria-expanded": o.opened.toString(),
          "aria-describedby": `${b(n)}-select-box-hint`,
          "aria-controls": `${b(n)}-select-box-list`,
          "aria-autocomplete": "both",
          name: "select-box-input",
          role: "combobox",
          autocomplete: "off",
          maxlength: o.maxLength,
          class: V(["ds-select-box-auto__field", { "select-box__field--active": o.value }]),
          placeholder: o.placeholder,
          onInput: q,
          onFocus: e[1] || (e[1] = (l) => a("focus")),
          onKeydown: [
            e[2] || (e[2] = g((l) => a("close"), ["tab"])),
            g(m(k, ["prevent"]), ["escape"]),
            e[3] || (e[3] = g(m((l) => [v(l), a("search-submitted")], ["prevent"]), ["enter"]))
          ]
        }, null, 42, j), [
          [
            D,
            s.value,
            void 0,
            { trim: !0 }
          ]
        ]),
        o.value ? (r(), u("button", {
          key: "clearValue",
          type: "submit",
          tabindex: "-1",
          "aria-label": o.labels.clearValueButton,
          class: "ds-button-link-icon ds-button-link-icon--black ds-select-box-auto__button",
          onClick: e[4] || (e[4] = m((l) => k({ label: "cross-circle-fill" }), ["prevent"]))
        }, [
          d(y, {
            category: "interface",
            name: "cross-circle-fill"
          })
        ], 8, z)) : (r(), u("button", {
          key: "submitValue",
          "aria-label": o.labels.submitValueButton,
          type: "submit",
          tabindex: "-1",
          class: V([{ "ds-select-box-auto__button--active": s.value }, "ds-button-link-icon ds-button-link-icon--black ds-select-box-auto__button ds-select-box-auto__button--submit"]),
          onClick: e[5] || (e[5] = m((l) => [v(l), a("search-submitted")], ["prevent"]))
        }, [
          d(y, {
            category: "arrows",
            name: "arrow-right"
          })
        ], 10, H))
      ]),
      d(A, {
        id: `${b(n)}-select-box-list`,
        opened: o.opened,
        options: c.value,
        onClose: e[6] || (e[6] = (l) => a("close")),
        onSelect: e[7] || (e[7] = (l) => [v(l), a("selected-item-clicked", l)])
      }, {
        default: N(() => [
          c.value.length === 0 ? (r(), u("li", M, "0 " + f(o.labels.results), 1)) : $("", !0)
        ]),
        _: 1
      }, 8, ["id", "opened", "options"]),
      o.labels.ariaLabelHint ? (r(), u("span", {
        key: 0,
        id: `${b(n)}-select-box-hint`,
        class: "ds-hidden"
      }, f(o.labels.ariaLabelHint), 9, O)) : $("", !0)
    ]));
  }
});
export {
  Z as default
};
